import React, { useRef } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import I1 from "../../assets/images/motor.png";
import I2 from "../../assets/images/motor2.jpg";
import I3 from "../../assets/images/motor3.png";
import I4 from "../../assets/images/motor4.png";

const images = [
    { id: 1, category: "MOTOCROSS GOGGLES", image: I1 },
    { id: 2, category: "RACING GEAR", image: I2 },
    { id: 3, category: "GT3 COLLECTION", image: I3 },
    { id: 4, category: "PROTECTIVE GEAR", image: I4 },
    { id: 5, category: "PROTECTIVE GEAR", image: I1 },
];

const PartnersSection = () => {
    const swiperRef = useRef(null);
    return (
        <div className="">
            <div className="">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold uppercase mb-2">Brendet tona partnere</h2>
                    <p className="text-gray-600">Zbulon brendet më të mira për stilin tuaj</p>
                </div>

                <div className="relative">
                    <Swiper
                        modules={[Navigation]}
                        onSwiper={(swiper) => (swiperRef.current = swiper)} 
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}
                        spaceBetween={10}
                        slidesPerView={1}
                        breakpoints={{
                            640: { slidesPerView: 2 },
                            1024: { slidesPerView: 4 }
                        }}
                        className="w-full"
                    >
                        {images.map((item) => (
                            <SwiperSlide key={item.id}>
                                <div className="relative h-96 lg:h-[80vh] overflow-hidden group">
                                    <img src={item.image} alt={item.category} className="w-full h-full object-cover" />
                                    <div className="absolute inset-0 flex items-end p-6 bg-gradient-to-t from-black/70 to-transparent">
                                        <h3 className="text-white text-lg font-semibold">{item.category}</h3>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <button className="absolute left-2 top-1/2 -translate-y-1/2 z-10" onClick={() => swiperRef.current?.slidePrev()}>
                        <svg width="50" height="50" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="42.6667" cy="42.6667" r="42.6667" transform="matrix(-1 0 0 1 85.334 0.666504)" fill="white" />
                            <path d="M48.1582 57.4134L36.5671 45.8223C35.1982 44.4534 35.1982 42.2134 36.5671 40.8445L48.1582 29.2534" stroke="black" stroke-width="2.66667" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </button>
                    <button className="absolute right-2 top-1/2 -translate-y-1/2 z-10" onClick={() => swiperRef.current?.slideNext()}>
                        <svg width="50" height="50" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="43.3346" cy="43.3332" r="42.6667" fill="white" />
                            <path d="M37.8398 57.4134L49.431 45.8223C50.7998 44.4534 50.7998 42.2134 49.431 40.8445L37.8398 29.2534" stroke="black" stroke-width="2.66667" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </button>
                </div>
            </div>
        </div>
    );
};

export default PartnersSection;